(() => {
  const initAnnouncements = (scope = document) => {
    scope.querySelectorAll('.mc-announcement__content--slider').forEach((slider) => {
      if (slider.dataset.mcReady === 'true') return;
      const items = [...slider.querySelectorAll('.mc-announcement__slide')];
      const timer = Number(slider.querySelector('.slideshow__inner')?.dataset.timer || 0);
      if (items.length < 2 || timer < 1000) return;
      slider.dataset.mcReady = 'true';
      let current = Math.max(0, items.findIndex((item) => item.classList.contains('slideshow__active')));
      window.setInterval(() => {
        items[current].classList.remove('slideshow__active');
        current = (current + 1) % items.length;
        items[current].classList.add('slideshow__active');
      }, timer);
    });
  };

  const initFaqSearch = (scope = document) => {
    scope.querySelectorAll('#faq-search').forEach((input) => {
      if (input.dataset.mcReady === 'true') return;
      input.dataset.mcReady = 'true';
      const page = input.closest('#faq-page')?.parentElement || document;
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase('fr');
        document.querySelectorAll('.faq-element').forEach((item) => {
          const match = !query || item.textContent.toLocaleLowerCase('fr').includes(query);
          item.hidden = !match;
          if (match && query && item.tagName === 'DETAILS') item.open = true;
        });
      });
    });
  };

  const initBuyNowState = (scope = document) => {
    scope.querySelectorAll('product-form').forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const buyButton = productForm.querySelector('[data-mc-buy-now]');
      if (!addButton || !buyButton || buyButton.dataset.mcReady === 'true') return;
      buyButton.dataset.mcReady = 'true';
      const sync = () => {
        buyButton.disabled = addButton.disabled || addButton.getAttribute('aria-disabled') === 'true';
      };
      sync();
      new MutationObserver(sync).observe(addButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    });
  };

  const init = (scope) => {
    initAnnouncements(scope);
    initFaqSearch(scope);
    initBuyNowState(scope);
  };

  document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
